import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { AmsFile } from '@core/objects/ams-file';
import { RelatedVersions } from '@core/objects/related';

@Component({
    selector: 'core-versions-related-group-item-files-list-checkbox',
    templateUrl: './related-group-item-files-list-checkbox.component.html',
    styleUrls: ['./related-group-item-files-list-checkbox.component.scss']
})
export class VersionsRelatedGroupItemFilesListCheckboxComponent implements OnInit {

    @Input() related: RelatedVersions;

    @Input() disabled: boolean;
    @Input()  selected: Array<AmsFile>;

    @Output() selectedChange = new EventEmitter<Array<AmsFile>>();

    public opened: boolean = true;
    // public firstOpened: boolean = false;

    constructor() { }

    ngOnInit() {

    }
    // to check and transmit up
    onChange(files: Array<AmsFile>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    openVersions() {
        // this.firstOpened = true;
        this.opened = !this.opened;
    }


}
